export enum AdminRoles {
  root = 1,
  admin = 2,
  editor = 3,
  staff = 4,
  resident = 5,
}

export interface AdminRoleList {
  code: AdminRoles;
  text: string;
}

export const adminRole: AdminRoleList[] = [
  {
    code: AdminRoles.root,
    text: '超級管理員',
  },
  {
    code: AdminRoles.admin,
    text: '最高管理員',
  },
  {
    code: AdminRoles.editor,
    text: '一般管理員',
  },
  {
    code: AdminRoles.staff,
    text: '招待人員',
  },
];
